import React from "react";
import { useLocation } from "react-router-dom";
import useSearchProducts from "../hooks/useSearchProducts";
import useCategories from "../hooks/useCategories";
import showErrorToast from "../utilities/Toast/showErrorToast";
import Navbar from "../components/Navbar/Navbar";

const Layout = ({ children, hasSearch }) => {
  let location = useLocation();

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  const {
    loadingProducts,
    setLoadingProducts,
    products,
    loadingSearch,
    search,
    setProducts,
    searchMessage,
    setSearchMessage,
    searchParams,
    setSearchParams,
    advancedSearchParams,
    setAdvancedSearchParams,
  } = useSearchProducts({
    searchTerm: query.get("search"),
  });

  const { categories, loadingCategories } = useCategories({
    onCategoriesError: (code) => showErrorToast({ code }),
  });
  return (
    <div>
      <Navbar
        hasSearch={hasSearch}
        isLoading={loadingSearch}
        onSearch={(expression, category) =>
          search({ expression, category, onError: (code) => showErrorToast({ code }) })
        }
        categories={categories}
        loadingCategories={loadingCategories}
      />
      {children}
    </div>
  );
};

export default Layout;
